import React from 'react';

import Register from './Register';

const RegisterCovid = () => <Register showCovid={true} />;

export default RegisterCovid;
